import axios from '@/axiosInterceptor';

const state = () => ({
  companyChangeOrders: [],
  pagination: {},
  companyOrdersDetails: [],
});

// actions
const actions = {
  async fetchCompanyChangeOrders({ commit }) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/company_change_orders?q[s]=id desc`
      );
      commit('setCompanyChangeOrders', res.data);
      commit('setPagination', res?.headers);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async fetchCompanyOrderDetail({ commit }, id) {
    try {
      const res = await axios.get(
        `${process.env.API_MONITOR}/api/v1/company_change_orders/${id}`
      );
      commit('setCompanyOrderDetail', res.data);
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async approve(_, id) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/company_change_orders/${id}/approve`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async reject(_, id) {
    try {
      const res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/company_change_orders/${id}/reject`
      );
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setCompanyChangeOrders(state, companyChangeOrders) {
    state.companyChangeOrders = companyChangeOrders;
  },
  setPagination(state, headers) {
    state.pagination = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  setCompanyOrderDetail(state, companyOrderDetail) {
    state.companyOrdersDetails = companyOrderDetail;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
